module.exports = __webpack_public_path__ + "img/scoreboard_image_error.07f5ebe0.svg";